import { useEffect } from 'react';

/**
 * Injects a Schema.org JSON-LD <script> into <head>.
 *
 * We do NOT use react-helmet for JSON-LD because it HTML-escapes the script
 * content (turning `"` into `&quot;`), which is NOT decoded inside <script>
 * tags and produces invalid JSON-LD. Injecting the script element directly
 * keeps the JSON intact.
 */
export const JsonLd = ({ data }) => {
  const json = JSON.stringify(data);
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = json;
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, [json]);
  return null;
};

export default JsonLd;
